'use strict';

module.exports = [
    {
        key: 'strainedRelationship',
        text: 'Is this a strained relationship?',
        type: 'boolean'
    },
    {
        key: 'strainedRelationshipDetails',
        text: 'Strained Relationship Details',
        type: 'string'
    },
    {
        key: 'livesWithPatient',
        text: 'Lives with patient?',
        type: 'boolean'
    },
    {
        key: 'mobileAccess',
        text: 'Grant access to mobile app?',
        type: 'boolean'
    },
    {
        key: 'living',
        text: 'Living?',
        type: 'boolean'
    },
    {
        key: 'deceasedAge',
        text: 'Age Deceased',
        type: 'integer'
    },
    {
        key: 'causeofDeath',
        text: 'Cause of death',
        type: 'string'
    },
    {
        key: 'healthIssues',
        text: 'Any history of significant health issues?',
        type: 'boolean'
    },
    {
        key: 'healthIssuesDetails',
        text: 'Significant Health Issues Details',
        type: 'string'
    },
    {
        key: 'geneticMarkers',
        text: 'Any history of significant genetic markers?',
        type: 'boolean'
    },
    {
        key: 'geneticMarkersDetails',
        text: 'Significant genetic markers details',
        type: 'string'
    },
    {
        key: 'caregiver',
        text: 'Caregiver',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'caregiverPrimary',
        text: 'Primary Caregiver',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'emergency',
        text: 'Emergency Contact',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'emergencyPrimary',
        text: 'Primary Emergency Contact',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'poa',
        text: 'Power of Attorney',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'permission',
        text: 'Permission to discuss case',
        type: 'boolean',
        preventReverse: true
    },
    {
        key: 'differentCareGoals',
        text: 'Patient and caregiver have differing goals of care?',
        type: 'boolean'
    },
    {
        key: 'adequateSupportCaregiver',
        text: 'Does this individual provide adequate caregiver support?',
        type: 'boolean'
    },
    {
        key: 'adequateSupport',
        text: 'Does this individual have adequate support?',
        type: 'boolean'
    },
    {
        key: 'isPatientCaregiver',
        text: 'Is the patient a caregiver for this person?',
        type: 'boolean'
    },
    {
        key: 'helpProvidingCare',
        text: 'Does the patient need additional help being the caregiver?',
        type: 'boolean'
    }
];
